(() => {
  const initProductForms = (root = document) => {
    root.querySelectorAll('[data-product-form]').forEach((form) => {
      if (form.dataset.initialized === 'true') return;
      form.dataset.initialized = 'true';
      const price = document.querySelector('[data-product-price]');
      const mobilePrice = document.querySelector('[data-mobile-price]');
      form.querySelectorAll('input[name="id"]').forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.dataset.variantPrice) return;
          if (price) price.textContent = input.dataset.variantPrice;
          if (mobilePrice) mobilePrice.textContent = input.dataset.variantPrice;
        });
      });
    });

    root.querySelectorAll('[data-scroll-to-form]').forEach((button) => {
      if (button.dataset.initialized === 'true') return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        document.querySelector('[data-product-form]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  };

  const initGalleries = (root = document) => {
    root.querySelectorAll('[data-gallery]').forEach((gallery) => {
      if (gallery.dataset.initialized === 'true') return;
      gallery.dataset.initialized = 'true';
      const track = gallery.querySelector('[data-gallery-track]');
      const items = [...gallery.querySelectorAll('[data-gallery-item]')];
      const thumbs = [...gallery.querySelectorAll('[data-gallery-thumbnail]')];
      const previous = gallery.querySelector('[data-gallery-previous]');
      const next = gallery.querySelector('[data-gallery-next]');
      const counter = gallery.querySelector('[data-gallery-current]');
      const dialog = gallery.querySelector('[data-gallery-dialog]');
      const dialogImage = gallery.querySelector('[data-gallery-dialog-image]');
      let current = 0;
      let frame;

      if (!track || items.length === 0) return;

      const update = (index) => {
        current = Math.max(0, Math.min(items.length - 1, index));
        if (counter) counter.textContent = String(current + 1);
        thumbs.forEach((thumb, thumbIndex) => {
          if (thumbIndex === current) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
        if (previous) previous.disabled = current === 0;
        if (next) next.disabled = current === items.length - 1;
      };

      const goTo = (index, behavior = 'smooth') => {
        const target = Math.max(0, Math.min(items.length - 1, index));
        track.scrollTo({ left: items[target].offsetLeft, behavior });
        update(target);
      };

      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const width = track.clientWidth || 1;
          update(Math.round(track.scrollLeft / width));
        });
      }, { passive: true });

      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(current - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(current + 1);
        }
      });

      previous?.addEventListener('click', () => goTo(current - 1));
      next?.addEventListener('click', () => goTo(current + 1));
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => goTo(Number(thumb.dataset.galleryThumbnail)));
      });

      gallery.querySelectorAll('[data-gallery-zoom]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!dialog || !dialogImage) return;
          dialogImage.src = button.dataset.zoomSrc || '';
          dialogImage.alt = button.dataset.zoomAlt || '';
          dialog.showModal();
        });
      });
      gallery.querySelector('[data-gallery-close]')?.addEventListener('click', () => dialog?.close());
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      update(0);
    });
  };

  const initCalendars = (root = document) => {
    root.querySelectorAll('[data-nakshatra-calendar]').forEach((calendar) => {
      if (calendar.dataset.initialized === 'true') return;
      calendar.dataset.initialized = 'true';
      const now = new Date();
      const horizon = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);
      let visible = 0;
      const windowContainer = calendar.querySelector('[data-calendar-windows]');
      const rows = [...calendar.querySelectorAll('[data-nakshatra-window]')];
      rows.sort((a, b) => new Date(a.dataset.start) - new Date(b.dataset.start));
      rows.forEach((row) => {
        windowContainer?.appendChild(row);
        const start = new Date(row.dataset.start);
        const end = new Date(row.dataset.end);
        const overlaps = !Number.isNaN(start.valueOf()) && !Number.isNaN(end.valueOf()) && end >= now && start <= horizon;
        row.hidden = !overlaps;
        if (overlaps) {
          row.classList.toggle('is-collapsed', visible >= 5);
          visible += 1;
        }
      });
      const empty = calendar.querySelector('[data-calendar-empty]');
      if (empty) empty.hidden = visible > 0;
      const toggle = calendar.querySelector('[data-calendar-toggle]');
      if (toggle && visible > 5) {
        toggle.hidden = false;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.addEventListener('click', () => {
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          calendar.querySelectorAll('[data-nakshatra-window]:not([hidden])').forEach((row, index) => {
            if (index >= 5) row.classList.toggle('is-collapsed', expanded);
          });
          toggle.setAttribute('aria-expanded', String(!expanded));
          toggle.textContent = expanded ? toggle.dataset.expandLabel : toggle.dataset.collapseLabel;
        });
      }
    });
  };

  const initialize = (root = document) => {
    initProductForms(root);
    initGalleries(root);
    initCalendars(root);
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
